const ROOT = '/tracker';
export const ISSUE_PARAM = 'issue';

/** URL-ы трекера. Хост (роутер, Sidebar) импортирует их отсюда, не наоборот */
export const trackerUrls = {
  root: ROOT,
  boards: `${ROOT}/boards`,
  board: (id: string) => `${ROOT}/boards/${id}`,
  /** Вкладка «Бэклог» доски: бэклог и спринты */
  boardBacklog: (id: string) => `${ROOT}/boards/${id}/backlog`,
  queues: `${ROOT}/queues`,
  queue: (key: string) => `${ROOT}/queues/${key}`,
  /** Создание задачи; `queue` — очередь, выбранная заранее */
  newIssue: `${ROOT}/new`,
  newIssueIn: (queueKey: string) => `${ROOT}/new?queue=${encodeURIComponent(queueKey)}`,
  /** Создание подзадачи: очередь и родитель заполнены */
  newSubissue: ({ queueKey, parentKey }: { queueKey: string; parentKey: string }) =>
    `${ROOT}/new?${new URLSearchParams({ queue: queueKey, parent: parentKey })}`,
  /**
   * Создание задачи из колонки доски: задача встанет на доску, в статус колонки (первый из тех,
   * что есть у очереди) и в спринт, выбранный на доске
   */
  newIssueOnBoard: ({
    boardId,
    statuses,
    sprintId,
    queueKey,
    summary,
  }: {
    boardId: string;
    statuses: string[];
    sprintId: string | null;
    /** Уже введённое в быстром создании — переносится в полную форму */
    queueKey: string | null;
    summary: string;
  }) =>
    `${ROOT}/new?${new URLSearchParams({
      board: boardId,
      status: statuses.join(','),
      ...(sprintId && { sprint: sprintId }),
      ...(queueKey && { queue: queueKey }),
      ...(summary && { summary }),
    })}`,
  /** Карточка задачи — глобальный Drawer поверх любого экрана трекера, открывается по ?issue= */
  issue: (key: string) => `${ROOT}?${ISSUE_PARAM}=${encodeURIComponent(key)}`,
};
